module.exports = __webpack_public_path__ + "img/新闻资讯_03.7422464d.png";